import { app } from '../../../../../../app';
import { Controller } from './edit.controller';

app.component('editMainProfile', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./edit.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/main/edit/edit.component.js